import React, { FC } from 'react';

import s from './styles.scss';

interface Props {
  videoId: string;
}

export const Youtube: FC<Props> = ({ videoId }) => {
  const url = 'https://www.youtube-nocookie.com/embed/' + videoId + '?autoplay=1';

  return (
    <iframe
      title="video"
      frameBorder="0"
      allowFullScreen
      allow="autoplay;encrypted-media;picture-in-picture"
      src={url}
      className={s.youtube}
    />
  );
};
